import React from 'react';
import Colors from '../../../shared/theme/colors';
import Fonts from '../../../shared/theme/fonts';
import commonStyle from '../../../shared/theme/common-style';
import styleImage from '../../../shared/components/rbh-image/styles';

export default {
  defaultContent: {
    backgroundColor: Colors.white,
    padding: 20,
  } as React.CSSProperties,
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingBottom: 16,
    height: 56
  } as React.CSSProperties,
  headerText: {
    fontSize: 24
  } as React.CSSProperties,
  tableWrapper: {
    backgroundColor: Colors.white,
    padding: 20
  } as React.CSSProperties,
  searchBox: {
    padding: '14px 10px'
  },
  promotionText: {
    ...Fonts.style.header,
    fontSize: Fonts.size.text12,
    color: Colors.lightPurple
  },
  iconPromotion: {
    ...styleImage.iconS,
    ...commonStyle.marginRightSmall
  }
};
